import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';
import { createQuerySchemaWithPagination } from '../shared';

export const selectOwnerSchema = createSelectSchema(schema.owners);

export const insertOwnerSchema = createInsertSchema(schema.owners, {
  name: z.string().min(1),
});

export const updateOwnerSchema = insertOwnerSchema.partial().extend({
  id: z.string(),
});

const OwnersQuerySchema = z.object({
  search: z.string().optional(),
  name: z.string().optional(),
  stateId: z.string().uuid().optional(),
  // Multi-state filter — agent surface resolves "GA, FL, TX" into a
  // list of stateIds and passes them as one IN-clause query instead
  // of fanning out a separate call per state. UI keeps using `stateId`
  // (singular); both compile to the same index lookup so no plan
  // regression.
  stateIds: z.array(z.string().uuid()).optional(),
  createdAt: z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
});

export const getOwnersQuerySchema = createQuerySchemaWithPagination(
  OwnersQuerySchema,
  { id: 'name', desc: false },
);

export const getOwnersCountQuerySchema = OwnersQuerySchema;
